import { ContextualField } from '../../../models/ContextualField';
import { PropertyType } from '../../../models/enum';

export const ValueFieldWidth: ContextualField = {
    propertyType: PropertyType.Number,
    modelName: 'valueFieldWidth',
    propertyName: 'valueFieldWidthProperty',
    label: 'Width in EM of value field',
    icon: 'fa-arrows-h',
    required: false,
    isValid: (value: string) => {
        const parsed = parseInt(value);
        let error: { [key: string]: boolean };
        if (!error && !value) {
            error = { 'required': !(value === null || value === undefined || value === '') };
        }
        if (!error && isNaN(parsed)) {
            error = { 'float': !isNaN(parsed) };
        }
        if (!error) {
            error = { 'min': !(parsed < 6) };
        }
        return error;
    },
    messages: [
        { key: 'required', value: 'Width is required' },
        { key: 'float', value: 'Width must be an integer greater than 5.' },
        { key: 'min', value: 'Width must be an integer greater than 5.' }
    ]
};